import { Currency } from "@redotech/money/currencies";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const addOutboundFunds = {
  name: "addOutboundFunds" as const,
  input: z.object({
    amount: z.number(),
    alertThreshold: z.number(),
    currency: createEnum(Currency),
    paymentMethodId: z.string(),
  }),
  output: z.object({ balance: z.string() }),
};
